<template>
    <ServicePageLayout
        title="Электронные приглашения"
        description="Создаю красивые сайты-приглашения на свадьбу и другие события. Такой формат удобно отправлять гостям, дополнять анкетой, картой, таймером и программой мероприятия."
        :includes="includes"
        :audience="audience"
        :steps="steps"
        price="Стоимость сайта-приглашения — от 8 000 ₽. Сроки — от 2 рабочих дней."
    />
</template>

<script setup>
import ServicePageLayout from '@/components/cards/ServicePageLayout.vue';

const includes = [
    'индивидуальное или шаблонное оформление',
    'информация о дате, времени и месте события',
    'программа мероприятия и таймер',
    'карта, контакты и кнопки связи',
    'анкета или форма подтверждения присутствия',
];

const audience = [
    'парам, которые готовятся к свадьбе',
    'организаторам мероприятий',
    'тем, кто хочет заменить бумажные приглашения сайтом',
    'клиентам, которым важно быстро и красиво пригласить гостей',
];

const steps = [
    'обсуждение стиля и наполнения приглашения',
    'подготовка структуры страницы',
    'создание дизайна или адаптация шаблона',
    'разработка интерактивных блоков',
    'проверка и публикация приглашения',
];
</script>